export const FRIENDS_AND_FAMILY_DISCOUNT_PAGE_SLUG = 'friends-and-family'
export const FRIENDS_AND_FAMILY_REFERRAL_EMAIL_QUERY_PARAM = 'referralEmail'
